module.exports = __webpack_public_path__ + "static/media/insta3.cb18cedb.png";